import { useState, useEffect } from 'react';
import { PricingPageShopProduct_magento2_products_items_Magento2_ConfigurableProduct_variants as MagentoProductVariants } from './__generated__/PricingPageShopProduct';

const useProductVariant = (
  variants: (MagentoProductVariants | null)[] | null,
  preselectedSKU?: string | null
) => {
  const [
    selectedVariant,
    setSelectedVariant,
  ] = useState<MagentoProductVariants | null>(null);

  useEffect(() => {
    const preselectedVariant =
      variants?.find((v) => v?.product?.sku === preselectedSKU) ?? null;
    const defaultVariant = variants?.find(
      (variant) => variant?.product?.isDefaultWithinAllVariants
    );
    const firstVariant = variants?.[0];

    if (preselectedSKU && preselectedVariant) {
      setSelectedVariant(preselectedVariant);
    } else if (defaultVariant) {
      setSelectedVariant(defaultVariant);
    } else if (firstVariant) {
      setSelectedVariant(firstVariant);
    }
  }, []);

  return {
    selectedVariant,
    setSelectedVariant,
  };
};

export default useProductVariant;
